import React from 'react'
import PropTypes from 'prop-types'
import {Button, Flex, Stack, Text, useStyleConfig, Link as ChakraLink} from '@chakra-ui/react'
import {Link as RouterLink} from 'react-router-dom'

const NewsletterModal = ({subscribeGroup}) => {
    const styles = useStyleConfig('PreFooter')

    const isExternalUrl = !!subscribeGroup?.is_external_url

    const buttonProps = !subscribeGroup?.cta?.href
        ? {
              id: 'js-show-newsletter-popup',
          }
        : isExternalUrl
        ? {
              as: ChakraLink,
              isExternal: true,
              href: subscribeGroup?.cta?.href,
          }
        : {
              id: 'js-show-newsletter-popup',
              as: RouterLink,
              to: subscribeGroup?.cta?.href,
          }

    return (
        <Flex {...styles.container} data-testid="newsletter-container">
            <Flex {...styles.newsletterFlex} data-testid="newsletter-flex">
                <Stack {...styles.newsletterStack} data-testid="newsletter-stack">
                    <Text {...styles.newsletterHeader} data-testid="newsletter-modal.header">
                        {subscribeGroup?.title}
                    </Text>
                    <Text {...styles.newsletterText} data-testid="newsletter-modal.text">
                        {subscribeGroup?.subtitle}
                    </Text>
                </Stack>
                <Button
                    variant="primary"
                    aria-label={`subscribe to ${subscribeGroup?.title}`}
                    className="del-newsletter__button"
                    {...buttonProps}
                    {...styles.newsletterButton}
                >
                    {subscribeGroup?.cta?.title}
                </Button>
            </Flex>
        </Flex>
    )
}

NewsletterModal.propTypes = {
    subscribeGroup: PropTypes.shape({
        title: PropTypes.string,
        subtitle: PropTypes.string,
        cta: PropTypes.shape({href: PropTypes.string, title: PropTypes.string}),
        is_external_url: PropTypes.bool,
    }),
}

export default NewsletterModal
